// @flow
import * as React from 'react'

import DefinitionTooltip from 'components/ui/DefinitionTooltip'
import {mountReactNode} from '../../reactRoots'

const notRenderedTooltipSelector = '[data-react-island-component-value="Glassfrog.components.ui.DefinitionTooltip"]:empty'

const renderTooltip = (props, wrapper) => {
  const reactTooltip = React.createElement(DefinitionTooltip, props)

  mountReactNode(reactTooltip, wrapper)
}

const renderNotRenderedTooltip = (tooltipDomElement: HTMLElement) => {
  const stringifiedReactProps = tooltipDomElement.dataset.reactIslandPropsValue
  const reactProps = JSON.parse(stringifiedReactProps)

  renderTooltip(reactProps, tooltipDomElement)
}

const renderNotRenderedTooltips = () => {
  Array.from(document.querySelectorAll(notRenderedTooltipSelector))
    .forEach(renderNotRenderedTooltip)
}

export default renderNotRenderedTooltips
